import { getCookie } from 'cookies-next/client';

import { uiConfig } from '@/config';
import { XID_COOKIE } from '@/constants/cookies';
import { getUserInfo } from '@/features/auth/client/getUserInfo';
import { isMvpdAuthenticated } from '@/features/auth/isMvpdAuthenticated';
import { getAuthSDK } from '@/sdk/client/getAuthSDK';

export async function mvpdLogOut(): Promise<void> {
  try {
    const xid = getCookie(XID_COOKIE);
    const { accessToken } = getUserInfo();

    if (xid && isMvpdAuthenticated(accessToken)) {
      await getAuthSDK().logoutOfMVPDV3({ deviceId: xid, clientId: uiConfig.clientId });
    }
  } catch {}
}
